import { API } from '@Providers';

// TODO - AF-545 Missing interface
export default async function (payload: string) {
  const endpoint = `/api/shelter/cart/get-discount/${payload}`;

  return API({ endpoint, method: 'post' });
}
